<template>
      <div :class="UseColumnDinamic ? Column : 'col-md-3'">

		<b-modal
			v-if="activateModalDiagnosis"
            :no-close-on-backdrop="true"
            :modal-class="'is-draggable'"
            scrollable
            @shown="prepararDrag"
            centered
            size="xl"
            @cancel="this.emitEventCancel"
            :id="ModalIdDiagnosis"
            :title="this.$t('Nurses.MarsMedication')"
            :ok-title="$t('Shared.Save')"
            @ok="handleOk"
            style="padding:none!important;"
            :cancel-title="$t('Shared.BtnCancel')"

        >
           <PatientDiagnosis v-bind:PatientCode="this.PatientCode" @OnUpdateDiagnose="updateDiagnose"></PatientDiagnosis>

        </b-modal>
		<!--class="col-md-4 grid-margin stretch-card"-->
					<div class="card activeCard">
						<div class="card-body">
						<div v-if="isUsePatientInfo" class="d-flex align-items-start justify-content-between pointer forceLTR">
							<h6 v-on:click="GoToPatientInfo" class="card-title flex-grow lower-line text-truncate">{{ $t('Shared.Diagnoses') }}</h6><i class="mdi mdi-arrow-right-drop-circle text-corporate" v-on:click="this.GoToPatientInfo"></i>
						</div>
						<div v-if="!isUsePatientInfo" class="d-flex align-items-start justify-content-between">
							<h6 class="card-title flex-grow lower-line text-truncate">{{ $t('Shared.Diagnoses') }}</h6>
						</div>
							<div class="text-muted p-fixed cutescroll">
						<p v-if="Diagnosis.length === 0">{{ $t('Shared.NoKnownDiagnosis') }}</p>
						<ul>
							<li v-for="(it, index) in Diagnosis" :key="`it.diagCode-${index}`">{{it.diagName}}</li>
						</ul>
						</div>
						</div>
						</div>
					</div>
</template>

<script>
import DBFunctions from '@/common/DBFunctions.js'
import PatientDiagnosis from '@/components/pages/patients/Diagnosis'
  export default {
    props: {
		PatientCode:String,
		UseColumnDinamic:Boolean,
		VisibleDiagnosis:Boolean,
		Column:String,
		ModalIdDiagnosis:String,
		actId: String
   },
   mixins: [DBFunctions],
   components:{PatientDiagnosis},
    data() {
      return {
		Diagnosis:[],
		activateModalDiagnosis:true,
		isUsePatientInfo: this.$store.state.isUsePatientInfo
      }
    },

  methods:{
	prepararDrag() {
  this.$nextTick(() => {
    const outer = document.getElementById(`${this.ModalIdDiagnosis}___BV_modal_outer_`);
    if (!outer) {
      return;
    }

    const dialog = outer.querySelector(".modal-dialog");
    const header = outer.querySelector(".modal-header");

    if (!dialog || !header) {
      return;
    }

    if (outer.classList.contains("is-draggable"))
            return;

    header.style.cursor = "move";

    header.onmousedown = (e) => {
      e.preventDefault();

      // Obtener posición actual antes de tocar estilos
      const rect = dialog.getBoundingClientRect();
      const offsetX = e.clientX - rect.left;
      const offsetY = e.clientY - rect.top;

      // Fijar posición actual (solo en el primer movimiento)
      dialog.style.width = `${rect.width}px`;
      dialog.style.height = `${rect.height}px`;
      dialog.style.position = "fixed";
      dialog.style.left = `${rect.left}px`;
      dialog.style.top = `${rect.top}px`;
      dialog.style.margin = 0;
      dialog.style.transform = "none";

      const moveHandler = (eMove) => {
        dialog.style.left = `${eMove.clientX - offsetX}px`;
        dialog.style.top = `${eMove.clientY - offsetY}px`;
      };

      document.addEventListener("mousemove", moveHandler);
      document.addEventListener(
        "mouseup",
        () => document.removeEventListener("mousemove", moveHandler),
        { once: true }
      );
    };
  });
},
    updateDiagnose() {
        this.getDiagnosis();
    },

	async getDiagnosis(){
		this.Diagnosis = await this.getPatientDiagnosis(this.PatientCode);
	},
	emitEventCancel(){
		//this.activateModalDiagnosis = false;
		this.$bvModal.hide(this.ModalIdDiagnosis);
        //this.getDiagnosis();
	},
	handleOk(){
        this.getDiagnosis();
	},

	GoToPatientInfo(){
		if(!this.VisibleDiagnosis){
            if(this.$route.name.includes('patient')){
				this.$router.push({ name: "patient-diagnosis", params: { id: this.PatientCode } }).catch(()=>{});
			}
			if(this.$route.name.includes('Clinical')){
				this.$router.push({ name: "Clinical-diagnosis", params: { id: this.PatientCode,recordid:this.$route.params.recordid } }).catch(()=>{});
			}
            if(this.$route.name.includes('appointment')){
				this.$router.push({ name: "appointmentDB-diagnosis", params: { id: this.PatientCode,actId: this.actId } }).catch(()=>{});
			}
			/*if (this.actId)
				this.$router.push({ name: "appointmentDB-diagnosis", params: { id: this.PatientCode, actId: this.actId } }).catch(()=>{});
			else
				this.$router.push({ name: "patient-diagnosis", params: { id: this.PatientCode } }).catch(()=>{});*/
		}else{
			//this.activateModalDiagnosis = true;
			this.$bvModal.show(this.ModalIdDiagnosis);
		}

    },
  },
   mounted() {
	this.getDiagnosis();
   }
}

</script>
